import React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress for loading indicator
import { TextView } from "@components";
import WheelCard from "./WheelCard";
import { colors } from "../../../utils";

function Wheels({ wheels, onWheelClick, onLoadMore, isLoading, hideLoadMore }) {
  return (
    <div style={{ overflowY: "auto", height: "100vh" }}>
      {wheels.length === 0 && isLoading && (
        <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
          <CircularProgress />
        </Box>
      )}
      {wheels.length > 0 && (
        <Grid container sx={{ py: 1 }}>
          {wheels.map((wheel, index) => (
            <Grid item xs={4} sm={4} key={index}>
              <WheelCard
                onWheelClick={onWheelClick}
                mainName={
                  wheel?.user_profile?.first_name +
                  " " +
                  wheel?.user_profile?.last_name
                }
                data={wheel}
              />
            </Grid>
          ))}
        </Grid>
      )}
      {!isLoading && wheels.length === 0 && (
        <Box
          sx={{
            py: 5,
            backgroundColor: "#F6F7F9",
            borderRadius: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <TextView
            style={{
              fontWeight: "500",
              color: "#123051",
              fontSize: "20px",
              lineHeight: "25px",
              textAlign: "center",
            }}
          >
            No Wheels Available!
          </TextView>
        </Box>
      )}
      {wheels.length > 0 && hideLoadMore && (
        <Button
          onClick={onLoadMore}
          variant="contained"
          sx={{
            margin: "20px auto",
            display: "block",
            backgroundColor: colors.primary,
            width: "10vw",
            height: "5vh",
          }}
          disabled={isLoading}
        >
          {isLoading ? <CircularProgress size={24} /> : "Load More"}
        </Button>
      )}
    </div>
  );
}

Wheels.propTypes = {
  wheels: PropTypes.array,
  onWheelClick: PropTypes.func,
  onLoadMore: PropTypes.func,
  isLoading: PropTypes.bool,
};

Wheels.defaultProps = {
  wheels: [],
  onWheelClick: () => {},
  onLoadMore: () => {},
  isLoading: false,
};

export default Wheels;
